"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Users = /*#__PURE__*/function () {
  function Users(registry) {
    (0, _classCallCheck2["default"])(this, Users);
    this._api = registry;
    this.ApiKeys = new _apiKeys["default"](registry.UserAccess, {
      parentRoutes: {
        get: 'user_ids.user_id',
        list: 'user_ids.user_id',
        create: 'user_ids.user_id',
        update: 'user_ids.user_id'
      }
    });
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Users, [{
    key: "_addState",
    value: function _addState(fieldMask, user) {
      // Ensure to set STATE_REQUESTED if needed, which gets stripped as null
      // value from the backend response.
      if (fieldMask && fieldMask.field_mask.paths.includes('state') && !('state' in user)) {
        user.state = 'STATE_REQUESTED';
      }

      return user;
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var _this = this;

        var fieldMask, response, users;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context.next = 3;
                return this._api.UserRegistry.List(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context.sent;
                users = _marshaler["default"].payloadListResponse('users', response);
                users.users.map(function (user) {
                  return _this._addState(fieldMask, user);
                });
                return _context.abrupt("return", users);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params, selector) {
        var _this2 = this;

        var fieldMask, response, users;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.EntityRegistrySearch.SearchUsers(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context2.sent;
                users = _marshaler["default"].payloadListResponse('users', response);
                users.users.map(function (user) {
                  return _this2._addState(fieldMask, user);
                });
                return _context2.abrupt("return", users);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function search(_x3, _x4) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id, selector) {
        var fieldMask, response, user;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context3.next = 3;
                return this._api.UserRegistry.Get({
                  routeParams: {
                    'user_ids.user_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context3.sent;
                user = this._addState(fieldMask, _marshaler["default"].payloadSingleResponse(response));
                return _context3.abrupt("return", user);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x5, _x6) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.UserRegistry.Delete({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteById(_x7) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.UserRegistry.Purge({
                  routeParams: {
                    user_id: id
                  }
                });

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function purgeById(_x8) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, patch) {
        var mask,
            response,
            result,
            user,
            _result,
            _args6 = arguments;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                mask = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : _marshaler["default"].fieldMaskFromPatch(patch);
                _context6.next = 3;
                return this._api.UserRegistry.Update({
                  routeParams: {
                    'user.ids.user_id': id
                  }
                }, {
                  user: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context6.sent;
                result = _marshaler["default"].unwrapUser(response); // Get new profile picture value if a new picture was uploaded, deleted, or
                // the primary email address was changed (in case of Gravar usage).

                if (!(mask.includes('profile_picture') || mask.includes('primary_email_address'))) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 8;
                return this.getById(id, ['profile_picture']);

              case 8:
                user = _context6.sent;
                _result = _marshaler["default"].unwrapUser(response);
                _result.profile_picture = user.profile_picture;

              case 11:
                return _context6.abrupt("return", result);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateById(_x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(user, invitationToken) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.UserRegistry.Create(undefined, {
                  user: user,
                  invitation_token: invitationToken
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].unwrapUser(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function create(_x11, _x12) {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(userId) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.UserAccess.ListRights({
                  routeParams: {
                    user_id: userId
                  }
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRightsById(_x13) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }()
  }, {
    key: "updatePasswordById",
    value: function updatePasswordById(id, payload) {
      return this._api.UserRegistry.UpdatePassword({
        routeParams: {
          'user_ids.user_id': id
        }
      }, {
        "new": payload["new"],
        old: payload.old,
        revoke_all_access: payload.revoke_all_access
      });
    }
  }, {
    key: "createTemporaryPassword",
    value: function createTemporaryPassword(id) {
      return this._api.UserRegistry.CreateTemporaryPassword({
        routeParams: {
          'user_ids.user_id': id
        }
      });
    } // Invitations.

  }, {
    key: "sendInvite",
    value: function () {
      var _sendInvite = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(email) {
        var response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.UserInvitationRegistry.Send(undefined, email);

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].unwrapInvitation(response));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function sendInvite(_x14) {
        return _sendInvite.apply(this, arguments);
      }

      return sendInvite;
    }()
  }, {
    key: "getAllInvitations",
    value: function () {
      var _getAllInvitations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(params, selector) {
        var _this3 = this;

        var fieldMask, result, invitations;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context10.next = 3;
                return this._api.UserInvitationRegistry.List(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                result = _context10.sent;
                invitations = _marshaler["default"].payloadListResponse('invitations', result);
                invitations.invitations.map(function (i) {
                  return _this3._addState(fieldMask, i);
                });
                return _context10.abrupt("return", invitations);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAllInvitations(_x15, _x16) {
        return _getAllInvitations.apply(this, arguments);
      }

      return getAllInvitations;
    }()
  }, {
    key: "deleteInvite",
    value: function () {
      var _deleteInvite = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(email) {
        var response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._api.UserInvitationRegistry.Delete(undefined, email);

              case 2:
                response = _context11.sent;
                return _context11.abrupt("return", _marshaler["default"].unwrapInvitation(response));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function deleteInvite(_x17) {
        return _deleteInvite.apply(this, arguments);
      }

      return deleteInvite;
    }()
  }]);
  return Users;
}();

var _default = Users;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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